import { useMemo } from "react";
import { useSelector } from "react-redux";

import { tabs_button } from "../../../../../assets/data";
import { viewTabPermission } from "../../../../../lib/permissions";
import {
    computeVisiblePatientTabItems,
    getCaseTypeTabConfig,
    isCaseDetailSectionVisible,
} from "../../../../../lib/patientTabVisibility";

import CaseDrawerSection from "../sections/CaseDrawerSection";
import AttorneyDrawerSection from "../sections/AttorneyDrawerSection";
import PracticeDrawerSection from "../sections/PracticeDrawerSection";
import LiabilityDrawerSection from "../sections/LiabilityDrawerSection";
import MedPayDrawerSection from "../sections/MedPayDrawerSection";
import UMDrawerSection from "../sections/UMDrawerSection";
import MajorMedDrawerSection from "../sections/MajorMedDrawerSection";
import WorkerCompDrawerSection from "../sections/WorkerCompDrawerSection";
import ServicesSection from "../sections/ServicesSection";

export default function CaseDetailTab({ classes, goToCaseTabHandler, data, caseData }) {
    const drawerData = caseData != null && typeof caseData === "object" ? caseData : {};
    const activeCase = caseData != null && typeof caseData === "object" ? caseData : null;

    const user = useSelector((state) => state.user.user);

    const permissionTabs = useMemo(() => {
        const p = viewTabPermission(tabs_button, user?.permissions);
        return Array.isArray(p) ? p : [];
    }, [user?.permissions]);

    const visiblePatientTabs = useMemo(() => {
        if (!activeCase?.case?.case_type_id) {
            return null;
        }
        const foundItem = getCaseTypeTabConfig(activeCase);
        if (!foundItem) {
            return null;
        }
        return computeVisiblePatientTabItems({
            activeCase,
            permission_tabs: permissionTabs,
            foundItem,
        });
    }, [activeCase, permissionTabs]);

    const show = (sectionKey) => isCaseDetailSectionVisible(sectionKey, visiblePatientTabs);

    return (
        <div className={`${classes.row} ${classes.caseDetailTabRoot}`}>
            {show("case") && (
                <CaseDrawerSection
                    classes={classes}
                    goToCaseTabHandler={goToCaseTabHandler}
                    drawerData={drawerData}
                />
            )}
            {show("attorney") && (
                <AttorneyDrawerSection
                    classes={classes}
                    drawerData={drawerData}
                    goToCaseTabHandler={goToCaseTabHandler}
                />
            )}
            {show("practice") && (
                <PracticeDrawerSection
                    classes={classes}
                    column={3}
                    activeCase={activeCase}
                    drawerData={drawerData}
                />
            )}
            {show("liability") && (
                <LiabilityDrawerSection
                    classes={classes}
                    drawerData={drawerData}
                    goToCaseTabHandler={goToCaseTabHandler}
                />
            )}
            {show("medpay_pip") && (
                <MedPayDrawerSection
                    classes={classes}
                    drawerData={drawerData}
                    goToCaseTabHandler={goToCaseTabHandler}
                    data={data}
                />
            )}
            {show("um") && (
                <UMDrawerSection
                    classes={classes}
                    drawerData={drawerData}
                    goToCaseTabHandler={goToCaseTabHandler}
                    data={data}
                />
            )}
            {show("major_med") && (
                <MajorMedDrawerSection
                    classes={classes}
                    drawerData={drawerData}
                    goToCaseTabHandler={goToCaseTabHandler}
                />
            )}
            {show("workers_comp") && (
                <WorkerCompDrawerSection
                    classes={classes}
                    drawerData={drawerData}
                    goToCaseTabHandler={goToCaseTabHandler}
                />
            )}
            {show("services") && (
                <ServicesSection
                    classes={classes}
                    drawerData={drawerData}
                    goToCaseTabHandler={goToCaseTabHandler}
                    column={5}
                    applyHiddenDefaultFilters={true}
                />
            )}
        </div>
    );
}
